import type { SWRConfiguration } from 'swr'
import useSWR from 'swr'

import { getProfile } from '../api/profileApi'
import { Profile } from '../types'

export default function useProfile(options?: SWRConfiguration) {
  return useSWR<Profile, Error>('profile', getProfile, options)
}
